import React from "react";
import { Link, useLocation } from "react-router-dom";
import TiktokIcon from "../assets/tiktok-icon.png";
import InstagramIcon from "../assets/instagram-icon.png";
import { useState } from "react";
import SuggestionsModal from "./SuggestionsModal";
import { COUNTRY_CITIES } from "../utils/countryMappings";
import OpenInNewTabIcon from "../assets/open-in-new-tab.png";
import Logo from "../assets/22N.png";
import { useCookieConsent } from "../hooks/useCookieConsent";

export default function Footer({ language, setLanguage }) {
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const location = useLocation();
  const { openSettings } = useCookieConsent();

  const handleLinkClick = (path) => {
    // If we're already on the relevant page and clicking a link, scroll to top
    if ((location.pathname === "/" || location.pathname === "/home") && path.includes("events?country=")) {
      // Home page community events
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else if (location.pathname === "/lifestyle" && path.includes("lifestyle?country=")) {
      // Lifestyle/deals page community deals
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const features = [
    {
      title: "Guestlist",
      link: "/events",
    },
    {
      title: "Community tickets",
      link: "/events",
    },
    {
      title: "Spin & Win",
      link: "/spin-and-win",
    },
    {
      title: "Member-only deals",
      link: "/lifestyle",
    },
  ];

  return (
    <div className="bg-[#1d1030] max-lg:pb-[100px] border-white/[0.06] border-t">
      <SuggestionsModal
        show={showFeedbackModal}
        setShow={setShowFeedbackModal}
        isFeedback={true}
      />
      <div className={`max-w-[1400px] w-[90%] mx-auto`}>
        {/* Mobile: Compact footer with just essential links */}
        <div className="lg:hidden flex items-center justify-center gap-[24px] py-[32px]">
          <Link to="/faq" className="text-[14px] text-[#A89FC0] hover:text-white transition-colors">About</Link>
          <span className="text-neutral-600">•</span>
          <Link to="/partners" className="text-[14px] text-[#A89FC0] hover:text-white transition-colors">Partners</Link>
          <span className="text-neutral-600">•</span>
          <Link to="mailto:info@22night.com" className="text-[14px] text-[#A89FC0] hover:text-white transition-colors">Contact</Link>
        </div>
        {/* Desktop: Full footer with all columns */}
        <div className="max-lg:hidden gap-[32px] grid grid-cols-5 py-[48px]">
          <div className="flex flex-col gap-[8px]">
            <div className="font-semibold text-[22px] text-white">
              Events
            </div>
            {Object.entries(COUNTRY_CITIES).map(([code, { label }]) => (
              <Link
                key={code}
                to={`/events?country=${code}`}
                className="font-normal text-[16px] text-[#A89FC0] hover:text-white transition-colors"
                onClick={() => handleLinkClick(`/events?country=${code}`)}
              >
                {label}
              </Link>
            ))}
          </div>
          <div className="flex flex-col gap-[8px]">
            <div className="font-semibold text-[22px] text-white">
              Features
            </div>
            {features.map((feature, index) => (
              <Link
                key={index}
                to={feature.link}
                className="font-normal text-[16px] text-[#A89FC0] hover:text-white transition-colors"
              >
                {feature.title}
              </Link>
            ))}
          </div>
          <div className="flex flex-col gap-[8px]">
            <div className="font-semibold text-[22px] text-white">About 22Night</div>
            <div className="flex flex-col gap-[8px]">
              <Link
                to={`/faq`}
                className="font-normal text-[16px] text-[#A89FC0] hover:text-white transition-colors text-start"
              >
                About us
              </Link>
              <Link
                to="https://wa.me/31639017197"
                target="_blank"
                className="font-normal text-[16px] text-[#A89FC0] hover:text-white transition-colors text-start"
              >
                Work at 22Night
              </Link>
              <button
                onClick={() => setShowFeedbackModal(true)}
                className="font-normal text-[16px] text-[#A89FC0] hover:text-white transition-colors text-start"
              >
                Give feedback
              </button>
            </div>
          </div>
          <div className="flex flex-col gap-[8px]">
            <div className="font-semibold text-[22px] text-white">For partners</div>
            <div className="flex flex-col gap-[8px]">
              <Link
                to={`/partners`}
                className="font-normal text-[16px] text-start text-[#7721E5] hover:text-[#924DEA] transition-colors"
              >
                Become a partner
              </Link>
            </div>
          </div>
          <div className="flex flex-col gap-[8px]">
            <div className="font-semibold text-[22px] text-white">Direct contact</div>
            <div className="flex flex-col gap-[8px]">
              <Link
                to={`mailto:info@22night.com`}
                className="text-[16px] font-normal flex items-center gap-[8px] text-[#7721E5] hover:text-[#924DEA] transition-colors"
              >
                <img src={OpenInNewTabIcon} alt="Email icon" className="w-[18px] h-[18px]" />
                info@22night.com
              </Link>
              <Link
                to="https://wa.me/31639017197"
                target="_blank"
                className="text-[16px] font-normal flex items-center gap-[8px] text-[#7721E5] hover:text-[#924DEA] transition-colors"
              >
                <img src={OpenInNewTabIcon} alt="WhatsApp icon" className="w-[18px] h-[18px]" />
                WhatsApp
              </Link>
            </div>
          </div>
        </div>
        <hr className="max-lg:hidden mb-[48px] mt-[16px] !border-white/[0.06]" />
        {/* Desktop: full bottom bar */}
        <div className="max-lg:hidden flex flex-col gap-[24px] pb-[16px]">
          <img src={Logo} alt="22Night logo" className="w-[100px] h-auto" />
          <div className="flex items-center justify-between">
            <div className="text-[16px] text-white">
              © 2026 22NIGHT •{" "}
              <span className="">
                <Link className="font-normal text-[16px] text-[#A89FC0] hover:text-white transition-colors" to={`/privacy`}>
                  Privacy
                </Link>
              </span>{" "}
              •{" "}
              <button
                onClick={() => openSettings('footer')}
                className="font-normal text-[16px] text-white hover:text-[#7721E5] transition-colors"
              >
                Cookie Settings
              </button>
            </div>
            <div className="flex items-center gap-[12px]">
              <Link to="https://www.tiktok.com/@22night.worldwide" target="_blank" className="flex items-center gap-[12px] hover:bg-[#D0ADFB1A] hover:shadow-lg rounded-lg font-normal !text-white">
                <img src={TiktokIcon} alt="Tiktok logo" className="w-[30px] h-[30px]" />
              </Link>
              <Link to="https://www.instagram.com/22night.worldwide/" target="_blank" className="flex items-center gap-[12px] hover:bg-[#D0ADFB1A] hover:shadow-lg rounded-lg font-normal !text-white">
                <img src={InstagramIcon} alt="Instagram logo" className="w-[30px] h-[30px]" />
              </Link>
            </div>
          </div>
        </div>
        {/* Mobile: minimal bottom bar */}
        <div className="lg:hidden flex flex-col items-center gap-[12px] pb-[16px]">
          <div className="text-[12px] text-[#A89FC0] text-center">
            © 2026 22NIGHT •{" "}
            <Link className="font-normal text-[12px] text-[#A89FC0] hover:text-white" to="/privacy">Privacy</Link>{" "}
            •{" "}
            <button
              onClick={() => openSettings('footer')}
              className="font-normal text-[12px] text-[#A89FC0] hover:text-white transition-colors"
            >
              Cookies
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
